// extracted by mini-css-extract-plugin
module.exports = {"shine":"loading_shine__szf25"};